import axios from 'axios'
import * as MODULES from '../module-codes'

export const state = {
  svg: null,
  rules: null,
  scores: null,
  caseletBank: null,
  markers: null,
  tokenSvg: null,
  tokens: null,
  moveMatrix: null,
  day: null,
  roleHierarchy: null,
  analyzed: null,
}

export const getters = {}

// dispatch
export const actions = {
  updateGameboard: ({ commit }, payload) => {
    commit('UPDATE_GAMEBOARD', payload)
  },
  populateGameboardFromDB: ({ commit, rootState }) => {
    // get basic rules for gameboard
    axios.post('/api/pcs/gameboard', {
      params: {
        pcs: localStorage.getItem('pcs'),
      },
    })
      .then(response => {
        let rules = response.data
        // get group number
        axios
          .post('/api/getGroup', {
            params: {
              pcs: localStorage.getItem('pcs'),
              classId: rootState.auth.classId,
            },
          })
          .then(response => {
            let group = response.data
            // get group module content
            axios.post('/api/group/gameboard', {
              params: {
                group: group,
              },
            }).then(response => {
              let settings = response.data.content
              if (Object.keys(settings).length <= 0) {
                // group module content empty
                axios.post('/api/gameboard/generate/group', {
                  params: {
                    group: group,
                    scoring: rules.settings.rules.scoring,
                    pcs: localStorage.getItem('pcs'),
                  },
                }).then(response => {
                  settings = response.data
                  /** This is temperary. This eventually will be done in the caselet bank generation **/
                  settings.caseletBank.bank[0].forEach(caselet => {
                    caselet.dispatch = false
                    caselet.dispatchMessage = ''
                    caselet.dispatchSent = false
                  })
                  Object.keys(settings).forEach(setting => {
                    rules.settings[setting] = settings[setting]
                  })
                  rules.settings.roleHierarchy = rules.settings.rules.roleHierarchy
                  rules.settings.analyzed = []
                  rules.settings.markers = []
                  commit('POPULATE_GAMEBOARD_FROM_DB', rules.settings)
                })
              } else {
                // group module content populated
                Object.keys(settings).forEach(setting => {
                  rules.settings[setting] = null
                  rules.settings[setting] = settings[setting]
                })
                if (rules.settings.markers === undefined) {
                  rules.settings.markers = []
                }
                commit('POPULATE_GAMEBOARD_FROM_DB', rules.settings)
              }
            })
          })
      })
  },
  populateFromDB: async ({ commit, dispatch, state }, payload) => {
    if (payload) {
      commit('POPULATE_GAMEBOARD_FROM_DB', payload)
    } else {
      dispatch('populateGameboardFromDB')
    }
  },
  saveState: async function({ state, rootState }) {
    let data = {}
    data.caseletBank = state.caseletBank
    data.day = state.day
    data.scores = state.scores
    data.tokens = state.tokens
    data.moveMatrix = state.moveMatrix
    data.roleHierarchy = state.rules.roleHierarchy
    data.analyzed = state.analyzed
    data.markers = state.markers

    axios.post('/api/getGroup', {
      params: {
        pcs: localStorage.getItem('pcs'),
        classId: rootState.auth.classId,
      },
    })
      .then(response => {
        axios.post('/api/update/group/module', {
          params: {
            group: response.data,
            moduleState: data,
            moduleName: MODULES.GAMEBOARD,
          },
        })
      })
  },
  // needs work
  sendMove: ({ dispatch, rootState }, payload) => {
    dispatch('saveState')

    axios.post('/api/message', {
      params: {
        message: payload.message,
        pcs: localStorage.getItem('pcs'),
        classId: rootState.auth.classId,
        recipient: payload.recipient,
        recipientid: payload.recipientid,
        name: payload.sender,
        id: payload.senderid,
        timestamp: new Date(),
      },
    })
  },
  // needs work
  newMove: ({ commit }, payload) => {
    state.tokens.players.forEach(token => {
      if (token.id === payload[0]) {
        token.actions.availabilities -= payload[1]
      }
    })
  },
  updateState: ({ dispatch }) => {
    dispatch('populateGameboardFromDB')
  },
}

// commit
export const mutations = {
  UPDATE_GAMEBOARD: (state, payload) => {
    state.svg = payload
  },
  POPULATE_GAMEBOARD_FROM_DB: (state, newContent) => {
    state.scores = newContent.scores
    state.day = newContent.day
    state.svg = newContent.svg
    state.rules = newContent.rules
    state.caseletBank = newContent.caseletBank
    state.tokenSvg = newContent.tokenSvg
    state.tokens = newContent.tokens
    state.moveMatrix = newContent.moveMatrix
    state.roleHierarchy = newContent.roleHierarchy
    state.analyzed = newContent.analyzed
    state.markers = newContent.markers
  },
}
